/**
 * 神州节能科技集团有限公司-数据
 */
// 神州节能科技集团有限公司
const sz_banner1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/sz_banner1.jpg";
const sz_banner2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/sz_banner2.JPG";
const sz_banner3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/sz_banner3.jpg";
const sz_banner4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/sz_banner4.jpg";
const sz_banner5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/sz_banner5.JPG";
const sz_banner6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/sz_banner6.JPG";
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
	homeData: {
		herderBanner: [sz_banner1, sz_banner2, sz_banner3, sz_banner4, sz_banner5, sz_banner6],
		//企业logo
		logo:
			"https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=48453179,296861027&fm=179&app=42&f=JPEG?w=400&h=400&s=04F7C93213486EEA5E7DF0C600009031",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szvRlogo.jpg",
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "",
		isVideo: true,
		videoLogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/szjnfm.jpg",
		videoUrl: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/szjn.mp4",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `神州节能科技集团有限公司（简称“神州集团”）始创于1979年，注册资金1个亿，总部位于河北省廊坊市大城县留各庄工业开发区，占地106万㎡，建筑面积68万㎡，拥有国际先进生产设备和技术。集团拥有六个子公司和八个产业园区，公司生产“福尔姆特®”、“绿都®”、“海普利德®”橡塑海绵制品，“豪森维尔®”、“金猴®”玻璃棉制品，“金猴®”硅酸铝制品和“优耳®”静音等高端绝热保温材料，年生产橡塑海绵制品260万立方米，玻璃棉制品23万吨，硅酸铝制品2.8万吨，解决了超过2000人就业问题的同时，更创造了可观的经济效益和社会效益。`,
		//公司官网
		website: "www.shenzhou.cc",
		operatingStatus: "正常在业",
		//经营品类
		categories: "橡塑、玻璃棉、硅酸铝",
		//公司地址
		companyAddress: "河北省廊坊市大城县留各庄工业开发区",
		site: "河北省廊坊市",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "10000万人民币",
		//成立日期
		establishment: "2001-4-29",
		//经营品牌
		brand: "“绿都”橡塑；“豪森维尔”玻璃棉；“金猴”硅酸铝",
		//主营产品
		mainProducts: " 橡塑、玻璃棉、硅酸铝",
		//企业名称
		headerTitle: "神州节能科技集团有限公司",
		moreInfoName: "神州节能科技集团有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.现款现结`,
		//工厂地址
		factoryAddress: "河北省廊坊市大城县留各庄工业开发区",
		//工厂人数
		factoryHeadcount: "2006",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "全国6个以上",
		factoryHeadcount: "106万㎡",
		capacity: "150万m³",

		//联系负责人
		person: "高亚辉 ",
		//联系电话
		contactNumber: "18533638509",
		//资质证书
		qualificationList: [
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szzz1.jpg",
			},
			{
				name: "中国绿色建材产品认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szzz2.png",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "4A良好行为企业",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szry1.jpg",
			},
			{
				name: "高新企业证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szry2.jpg",
			},
			{
				name: "能力资格证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szry3.png",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "武汉建工集团股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szhb1.png",
				desc: "",
			},
			{
				name: "华润置地有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szhb2.png",
				desc: "",
			},
			{
				name: "美的集团",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szhb3.png",
				desc: "",
			},
			{
				name: "格力集团",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szhb4.png",

				desc: "",
			},
			{
				name: "中石油",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szhb5.png",
				desc: "",
			},
			{
				name: "中石化",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szhb6.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 12,
				num: 12,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 5,
				num: 5,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
	listData: {
		productList: [
			{ name: "橡塑保温材料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp1.png" },
			{ name: "玻璃棉保温材料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp2.png" },
			{ name: "硅酸铝保温材料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp3.png" },
		],
		navList: [
			{
				name: "橡塑保温材料",
				isShow: false,
				id: 1,
				children: ["橡塑保温材料-板、管"],
			},
			{
				name: "玻璃棉保温材料",
				isShow: false,
				id: 2,
				children: ["玻璃棉保温材料-板、毡"],
			},
			{
				name: "硅酸铝保温材料",
				isShow: false,
				id: 3,
				children: ["硅酸铝保温材料-板、毡"],
			},
		],
	},
	productDetailsData: {
		橡塑保温材料: {
			name: "橡塑保温材料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp1.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp1.png",
				},
			],
			price: "1000",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp1.png"],
			modelNumberText: "板、管",
			brand: "绿都",
			describe:
				"用途：橡塑材料采用优质的橡胶和聚氯乙烯(NBR/PVC)为主要材料，经混炼、密炼、连续式挤出、加热发泡、冷却分切而成的混合发泡材料。橡塑保温材料是弹性闭孔发泡材料，具有导热系数低、防火阻燃、防潮阻湿、减振降噪、环保健康、使用寿命长、外观素雅美观、安装方便等优点。广泛应用于中央空调、建筑，化工，医药、轻纺、冶金、船舶，汽车，电器等相关冷热介质管道或容器，能达到降低冷损和热损的效果。加上施工简便，外观整洁美观，且产品不含纤维粉尘，不会滋生霉菌等有害物质，因此是一种高品质的新一代绝热保温材料。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht1.png"],
		},
		玻璃棉保温材料: {
			name: "玻璃棉保温材料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp2.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp2.png",
				},
			],
			price: "5500",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp2.png"],
			modelNumberText: "板、毡",
			brand: "豪森维尔",
			describe:
				"用途：一般民用和低温管道用的多 使用温度-120℃-400℃，用于建筑、石化、电力、冶金等领域保温隔热、吸声降噪。作用：墙体吸音、墙体隔音、墙体保温、墙体隔热",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		硅酸铝保温材料: {
			name: "硅酸铝保温材料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp3.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp3.png",
				},
			],
			price: "2500",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szcp3.png"],
			modelNumberText: "板、毡",
			brand: "金猴",
			describe:
				"用途：硅酸铝保温材料又名(硅酸铝复合保温涂料)，是一种新型的环保墙体保温材料。符合国家建筑标准，是众多房地产商，工程承包商，装饰工程商的必需材料。特点：绿色无害、吸水阻燃、密封稳固",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht3.png"],
		},
	},
	contactListData: {
		list: [
			{
				name: "高亚辉",
				position: "销售经理(全国)",
				id: "2",
				phoneNum: "18533638509",
				telephone: "--",
				color: "#007DFF ",
				email: "gaoyahui@shenzhou.cc",
			},
		],
	},
	caseData: {
		list: [
			{
				name: "北京城市副中心",
				id: 1,
				price: "562万",
				time: "2017",
				site: "北京市",
				type: "建筑",
				unit: "北京市设备安装工程集团有限公司",
				desc:
					"北京城市副中心的建设是为调整北京空间格局、治理大城市病、拓展发展新空间的需要，也是推动京津冀协同发展、探索人口经济密集地区优化开发模式的需要而提出的。规划范围为原通州新城规划建设区，总面积约155平方公里。外围控制区即通州全区约906平方公里，进而辐射带动廊坊北三县地区协同发展。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szgc1.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht1.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png" },
				],
				product: "橡塑保温材料",
			},

			{
				name: "国家会展中心-天津",
				id: 2,
				price: "28万",
				time: "2020",
				site: "天津市",
				type: "建筑",
				unit: "华德建安集团有限公司",
				desc:
					"国家会展中心(天津)集展览、会议、商业、办公、酒店功能于一体，总建筑面积约138万平方米。项目分两期建设，一期项目总建筑面积约为80万平方米，二期项目总建筑面积约为58万平方米。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szgc2.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht3.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht4.png" },
				],
				product: "橡塑保温材料",
			},

			{
				name: "西安地铁六号线二期",
				id: 3,
				price: "217万",
				time: "2021",
				site: "陕西省西安市",
				type: "地铁",
				unit: "中建安装集团有限公司",
				desc: "西安地铁6号线二期工程呈东西走向，东起灞桥区纺织城站，途经新城区、莲湖区，西至碑林区西北工业大学站。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szgc3.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht5.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht6.png" },
				],
				product: "玻璃棉保温材料",
			},

			{
				name: "哈工大机器人集团武汉产业基地施工项目",
				id: 4,
				price: "100万",
				time: "2021",
				site: "湖北省武汉市",
				type: "产业基地",
				unit: "武汉建工集团股份有限公司",
				desc:
					"A地块为商务用地，规划2栋2层商业楼，4栋18-23层办公楼（含商业），地下机动车位1153辆。B地块为居住用地，规划26栋4-6层住宅，7栋30-34层住宅（含商业、物业服务用房等），1栋2层商业及公配服务用房，1栋1层垃圾收集站及体育活动站，3栋1层配电房，1栋3层幼儿园，整体地下机动车位2666辆。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szgc4.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht7.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht8.png" },
				],
				product: "玻璃棉保温材料",
			},
			{
				name: "江西赣州耀能新能源洁净装饰机电工程",
				id: 5,
				price: "327万",
				time: "2022",
				site: "江西省赣州市",
				type: "产业基地",
				unit: "中国电子系统工程第二建设有限公司",
				desc:
					" 项目总投资300亿元；生产基地总建筑面积约38万平米，一期项目12GWh，占地520亩，二期项目产能规划30GWh，整体产能规划42GWh。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szgc5.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht9.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht10.png" },
				],
				product: "橡塑保温材料",
			},
		],
	},
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 9,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${2}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${2}.png`,
				title: "绿建认证",
				isShow: true,
			},
		],
	},
	successfulBidderData: {
		info: [
			{
				name1: "聊城市水兴市政工程有限公司保温材料采购",
				name2: "聊城市水兴市政工程有限公司保温材料采购项目（三次）",
				name3: "物资采购",
				date: "2023/3/21",
			},
			{
				name1: "天津石化南港120万吨/年乙烯及下游高端新材料 产业集群项目及存量部分 泡沫橡塑及铝箔玻璃棉制品一批",
				name2: "天津石化南港120万吨/年乙烯及下游高端新材料 产业集群项目及存量部分 泡沫橡塑及铝箔玻璃棉制品一批",
				name3: "物资采购",
				date: "2023/3/21",
			},
			{
				name1: "华润置地机械送排风、空调风、防排烟-华润建筑2022-2023年度国产玻璃棉集中采购",
				name2: "标段1：华润置地机械送排风、空调风、防排烟-华润建筑2022-2023年度国产玻璃棉集中采购",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "华能石洞口第一电厂2×65万千瓦等容量煤电替代项目纳米保温材料采购",
				name2: "华能石洞口第一电厂2×65万千瓦等容量煤电替代项目纳米保温材料采购",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "临淄北部热力中心项目一期材料采购",
				name2: "临淄北部热力中心项目一期材料采购（二标段保温采购）",
				name3: "物资采购",
				date: "2022/9/27",
			},

			{
				name1: "达拉特经济开发区工业蒸汽综合利用及管网建设项目管道保温材料采购",
				name2: "达拉特经济开发区工业蒸汽综合利用及管网建设项目管道保温材料采购",
				name3: "物资采购",
				date: "--",
			},

			{
				name1: "华润建筑有限公司2020-2021年度国产玻璃棉集中采购",
				name2: "华润建筑有限公司2020-2021年度国产玻璃棉集中采购",
				name3: "物资采购",
				date: "2020/8/25",
			},
			{
				name1: "苏州太湖国家旅游度假区自来水有限公司保温材料采购",
				name2: "苏州太湖国家旅游度假区自来水有限公司保温材料采购",
				name3: "物资采购",
				date: "2020/8/7",
			},
			{
				name1: "华润建筑2020-2021年度国产橡塑保温材料集中采购",
				name2: "华润建筑2020-2021年度国产橡塑保温材料集中采购",
				name3: "物资采购",
				date: "2020/6/23",
			},
			{
				name1: "宣城市节能利用集中供热项目（一期）高温玻璃棉项目",
				name2: "宣城市节能利用集中供热项目（一期）高温玻璃棉项目",
				name3: "物资采购",
				date: "2020/6/18",
			},
			{
				name1: "河北白沙烟草有限责任公司保定卷烟厂小五金（保温类）采购项目",
				name2: "河北白沙烟草有限责任公司保定卷烟厂小五金（保温类）采购项目",
				name3: "物资采购",
				date: "2019/8/19",
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "安装公司北京师范大学榆林学校（小学）建设项目橡塑、岩棉保温材料采购合同",
				name4: "陕西建工第九建设集团有限公司",
				name2: "北京师范大学榆林学校（小学）建设项目",
				name3: "物资采购",
				date: "2022年11月18日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "安装公司中科院橡塑保温材料采购合同",
				name4: "陕西建工第九建设集团有限公司",
				name2: "中科院洁净能源创新研究院榆林分院-安装工程",
				name3: "物资采购",
				date: "2022年4月7日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "陕建九建安装公司榆林市会展中心项目机房橡塑保温材料采购",
				name4: "陕西建工第九建设集团有限公司",
				name2: "榆林会展中心",
				name3: "物资采购",
				date: "2022年4月8日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "陕五建+安装公司+常宁体训基地+保温材料采购",
				name4: "陕西建工第五建设集团有限公司",
				name2: "陕五建安装公司二分司",
				name3: "物资采购",
				date: "2021年7月14日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "陕建一建-安装公司-三工程公司-西咸新区秦汉中心医院项目-橡塑保温合同",
				name4: "陕西建工第一建设集团有限公司",
				name2: "西咸新区秦汉中心医院EPC工程项目(一建安装)",
				name3: "物资采购",
				date: "2021年8月10日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "三建安装公司西安市红会医院高铁新城院区工程项目保温材料采购合同",
				name4: "陕西建工第三建设集团有限公司",
				name2: "西安市红会医院高铁新城院区工程项目",
				name3: "物资采购",
				date: "2021年6月17日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "安装公司中科院保温材料采购合同",
				name4: "陕西建工第九建设集团有限公司",
				name2: "中科院洁净能源创新研究院榆林分院-安装工程",
				name3: "物资采购",
				date: "2021年4月30日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "陕建安装集团石化公司 B1级 橡塑保温板",
				name4: "陕西建工安装集团有限公司",
				name2: "鱼化能源中心项目设备安装工程",
				name3: "物资采购",
				date: "2021年2月22日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "安装公司纪检委保温材料采购合同",
				name4: "陕西建工第九建设集团有限公司",
				name2: "榆林市纪委监委昌汉界基地扩建项目（安装）",
				name3: "物资采购",
				date: "2021年2月4日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "安装公司会展中心橡塑保温材料采购合同",
				name4: "陕西建工第九建设集团有限公司",
				name2: "榆林会展中心",
				name3: "物资采购",
				date: "2020年12月10日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "陕五建+安装公司+西安高新第一高中新校区EPC工程项目+保温材料采购合同+神州节能科技集团有限公司",
				name4: "陕西建工第五建设集团有限公司",
				name2: "陕五建安装公司三分司",
				name3: "物资采购",
				date: "2020年6月29日",
				out: true,
			},
			{
				企业名称: "神州节能科技集团有限公司",
				name1: "陕西奥体中心体育馆橡塑保温材料采购合同",
				name4: "陕西建工第三建设集团有限公司",
				name2: "陕西奥体中心体育馆项目",
				name3: "物资采购",
				date: "2019年12月28日",
				out: true,
			},
		],
	},
	lawData: {
		info: [
			{
				caseName: "河北华斯橡塑制品有限公司等再审行政判决书",
				// 案号
				reference: "（2021）京行再15号",
				// 案由
				cause: "--",
				//身份
				identity: "申请人",
				//类型
				caseType: "行政案件",

				date: "2022-06-28",
			},
			{
				caseName: "（2022）京行终1537号神州节能科技集团有限公司诉国家知识产权局因商标驳回复审行政纠纷二审行政判决书",
				// 案号
				reference: "（2022）京行终1537号",
				// 案由
				cause: "--",
				//身份
				identity: "上诉人",
				//类型
				caseType: "行政案件",

				date: "2022-06-14",
			},
			{
				caseName: "神州节能科技集团有限公司与国家知识产权局一审行政判决书",
				// 案号
				reference: "（2021）京73行初10788号",
				// 案由
				cause: "--",
				//身份
				identity: "原告",
				//类型
				caseType: "行政案件",

				date: "2022-06-02",
			},
			{
				caseName: "神州节能科技集团有限公司与国家知识产权局其他一审行政判决书",
				// 案号
				reference: "（（2021）京73行初14811号",
				// 案由
				cause: "--",
				//身份
				identity: "原告",
				//类型
				caseType: "行政案件",

				date: "2022-04-06",
			},
			{
				caseName: "神州节能科技集团有限公司、广州菱锋钢构有限公司买卖合同纠纷首次执行执行裁定书",
				// 案号
				reference: "（2021）粤0118执9994号",
				// 案由
				cause: "买卖合同纠纷",
				//身份
				identity: "申请执行人",
				//类型
				caseType: "执行案件",

				date: "2022-01-17",
			},
			{
				caseName: "神州节能科技集团有限公司、河南建工防腐有限公司买卖合同纠纷执行实施类执行裁定书",
				// 案号
				reference: "（2021）豫0728执464号",
				// 案由
				cause: "买卖合同纠纷",
				//身份
				identity: "申请执行人",
				//类型
				caseType: "执行案件",

				date: "2021-06-10",
			},
			{
				caseName:
					"原告淄博鼎力耐火材料有限公司与被告廊坊神州玻璃棉制品有限公司、神州节能科技集团有限公司、高铁彦买卖合同纠纷一案民事调解书",
				// 案号
				reference: "（2021）鲁0304民初539号",
				// 案由
				cause: "买卖合同纠纷",
				//身份
				identity: "被告",
				//类型
				caseType: "民事案件",

				date: "2021-04-28",
			},
			{
				caseName: "淄博鼎力耐火材料有限公司、廊坊神州玻璃棉制品有限公司其他民事裁定书",
				// 案号
				reference: "（2021）鲁0304财保4号",
				// 案由
				cause: "买卖合同纠纷",
				//身份
				identity: "被申请人",
				//类型
				caseType: "民事案件",

				date: "2021-01-11",
			},
			{
				caseName: "淄博鼎力耐火材料有限公司与廊坊神州玻璃棉制品有限公司神州节能科技集团有限公司合同纠纷",
				// 案号
				reference: "（2021）鲁0304执保7号",
				// 案由
				cause: "合同纠纷",
				//身份
				identity: "当事人",
				//类型
				caseType: "执行案件",

				date: "2021-01-08",
			},
		],
	},
	tipData: {
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
			{
				title: "高新技术企业",
			},
		],
	},
};
